import React from 'react';
import { SectionWrapper, FadeIn, CTAButton } from './Shared';
export const Pricing = () => {
  return <SectionWrapper id="pricing" className="bg-cream-dark" data-id="element-127">
      <div className="max-w-xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="text-center mb-10" data-id="element-130">
            <h2 className="text-3xl md:text-4xl font-bold text-sage-900 mb-4" data-id="element-131">
              💳 Accedé ahora
            </h2>
            <p className="text-lg text-slate-600" data-id="element-132">
              Acceso inmediato. Pago único. Sin suscripciones.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-133">
          <div className="bg-sage-900 rounded-3xl p-8 md:p-10 border-2 border-sage-400 shadow-xl relative overflow-hidden" data-id="element-134">
            <div className="absolute top-0 right-0 w-40 h-40 bg-sage-700 rounded-full blur-2xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-135" />

            <div className="relative z-10 text-center" data-id="element-136">
              <div className="bg-rose text-white text-xs font-bold uppercase tracking-wider py-1.5 px-4 rounded-full inline-block mb-5" data-id="element-137">
                ⭐ ACCESO COMPLETO
              </div>

              <h3 className="text-2xl font-bold text-white mb-3 uppercase tracking-wide" data-id="element-138">
                🏆 DESHINCHATE
              </h3>
              <p className="text-sage-200 mb-8 font-medium" data-id="element-139">
                Ebook completo + 6 Bonos exclusivos + Futuras actualizaciones
              </p>

              <div className="mb-8" data-id="element-140">
                <span className="text-lg text-sage-400 line-through block mb-1" data-id="element-141">
                  $69.990
                </span>
                <div className="flex items-center justify-center gap-2" data-id="element-142">
                  <span className="text-2xl" data-id="element-143">💥</span>
                  <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-144">
                    $19.990
                  </span>
                </div>
              </div>

              <CTAButton fullWidth data-id="element-145">👉 SÍ, QUIERO EMPEZAR AHORA</CTAButton>
            </div>
          </div>
        </FadeIn>
      </div>
    </SectionWrapper>;
};